module.exports = __webpack_public_path__ + "img/arrow-narrow-right.3529bb34.svg";